export default {"src":"/_next/static/media/gold-fish-icon.dc64ed15.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};